import React, {useRef} from "react";
// import videoBG from '../assets/videoBg.mp4'
import researchYourBusiness from '../assets/images/researchYourBusiness.webp'
import optimalStrategySelection from '../assets/images/optimalStrategySelection.webp'
import implementTheStrategy from '../assets/images/implementTheStrategy.webp'
import monitoringTheDeviation from '../assets/images/monitoringTheDeviation.webp'
import preDeadlineResults from '../assets/images/preDeadlineResults.webp'
import homePageBanner from '../assets/bannerImages/homePageBanner.webp'

import videoAdsBanner from '../assets/bannerImages/videoAdsBanner.jpg'
import websiteDevelopment from '../assets/bannerImages/websiteDevelopment.jpg'
import whatsAppMarketing from '../assets/bannerImages/WhatsAppMarketingBanner.jpeg'
import socialMediaMarketing from '../assets/bannerImages/socialMediaMarketing.webp'
import influencerMarketing from '../assets/bannerImages/influencerMarketing.jpg'
import emailMarketing from '../assets/bannerImages/emailMarketing.jpg'
import searchEngineOptization from '../assets/bannerImages/searchEngineOptimization.jpg'
import payPerClickMarekting from '../assets/bannerImages/payPerClickMarketing.jpg'
import bulkSMS from '../assets/images/bulkSMS.jpg' 

import Mycard from "./Mycard";
import Form from "./Form";

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import { Link } from "react-router-dom";

export default function Home(){
    return(
        <div className="home">
            {/* Row 1*/}
            <section className="r1">
            
                <div className="titles">
                    <h1 className="title">On a mission to help your business grow online</h1>
                </div>
                <div className="overlay"></div>
                <img loading="lazy" src={homePageBanner} className="home-banner-img"></img>
                {/* <video className="video1" src={videoBG} autoPlay loop muted playsInline/> */}
                <div className="shape">
                <Link to='/contact'><button className="shape-btn">Get A Quote</button></Link>
                </div>
            </section>
            {/* remianing rows */}
            
            <Row2/>
            <Row3/>
            <Row4/>
            <Row5/>
        </div>
    )
}
function Row2() {
  const boxRef = useRef(null); // Create a ref to hold the DOM element

  const moveLeft = () => {
    let width = boxRef.current ? boxRef.current.clientWidth : 0; // Handle potential null value
    boxRef.current.scrollLeft = boxRef.current.scrollLeft - width;
  }

  const moveRight = () => {
    let width = boxRef.current ? boxRef.current.clientWidth : 0; // Handle potential null value
    boxRef.current.scrollLeft = boxRef.current.scrollLeft + width;
  }

  return (
    <div className="home-r2">
      <h1 className="head">We help <span>your business</span> through:</h1>

      <div className="carousel">
        {/* <div className="buttons">
          <button className="prev-btn" onClick={moveLeft}><ArrowBackIosIcon /></button>
          <button className="next-btn" onClick={moveRight}><ArrowForwardIosIcon /></button>
        </div> */}

        <div className="card-container" ref={boxRef}>
          <Mycard img={socialMediaMarketing} head='Social Media Marketing' description="Let us boost your online presence through Social Media Marketing."/>
          <Mycard img={payPerClickMarekting} head='Pay Per Click (PPC) Marketing' description="Unlock conversions and engage audiences with our Pay Per Click strategies."/>
          <Mycard img={websiteDevelopment} head='Website Designing' description="Experience seamless website design blending aesthetics and functionality."/>
          <Mycard img={whatsAppMarketing} head='WhatsApp Marketing' description="Engage your audience with personalized WhatsApp Marketing campaigns."/>
          <Mycard img={bulkSMS} head='Bulk SMS' description="Stay connected with Bulk SMS campaigns tailored by us."/>
          <Mycard img={videoAdsBanner} head='Video Ads' description="Captivate your audience with Video Ads crafted by our team."/>
          <Mycard img={searchEngineOptization} head='Search Engine Optimization (SEO)' description="Boost website visibility and traffic with our SEO solutions."/>
          <Mycard img={emailMarketing} head='Email Marketing' description="Drive conversions through targeted Email Marketing campaigns."/>
          <Mycard img={influencerMarketing} head='Influencer Marketing' description="Amplify your brand's reach with strategic Influencer Marketing."/>
        </div>
      </div>
    </div>
  );
}


function Row3(){
    return(
        <div className="home-r3">
            <div className="container">
                <h1>What made <span>100+ brands</span> trust Bixian?</h1>
                <div className="content">
                   <p className="para">At Bixian, we're proud to have earned the trust of over 100 brands. 
                   Our commitment to excellence is reflected in everything we do. 
                   With a focus on delivering top-notch service and value, we strive to exceed expectations. 
                   Your success is our driving force, and we're here to support you every step of the way.
                   Learn about our core principles that define our approach to business.</p>
                    <ul className="qualities">
                      <li className="quality">Driven Results</li>
                      <li className="quality">Unbeatable Prices</li>
                      <li className="quality">Strategic Approach</li>
                      <li className="quality">Client-centric Services</li>
                      <li className="quality">Pre-deadline results</li>
                    </ul>
                </div>
            </div>
        </div>
    )
}


function Row4(){
    return(
        <div className="home-r4">
            <h1>How we help <span>your business</span> grow?</h1>
            <div className="superContainer">
            <div className="container">
              <Mycard className="r4-card" img={researchYourBusiness} head='Research Your Business' description='We study your business, competitors, and market to find the best strategy.'/>
              <Mycard className="r4-card" img={optimalStrategySelection} head='Optimal Strategy Selection' description='We choose the right plan for your business, making sure it works well.'/>
              <Mycard className="r4-card" img={implementTheStrategy} head='Implement The Strategy' description='We put our plan into action, making sure it fits your business.'/>
              <Mycard className="r4-card" img={monitoringTheDeviation} head='Monitoring The Deviation' description='We keep an eye on your progress, fixing any problems quickly.'/>
              <Mycard className="r4-card" img={preDeadlineResults} head='Pre-deadline Results' description='Finally we attain the goals with best results'/>
            </div>
            </div>
        </div>
    )
}

function Row5(){
  return(
    <div className="home-r5">
      
      <div className="strip">
        <h1>Connect With <span>Our Expert</span></h1>
        <p>We'll get back to you real quick</p>
      </div>

      <div className="contact">
        <div className="form-body">
          <Form/>
        </div>
        <div className="map">
        <iframe title="bixian" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d242.35369675341832!2d79.43400459414649!3d13.61761764552607!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a4d4bbb6569873f%3A0xb33d8da92b5c03c4!2sLakshmi%20Beauty%20Care%20%26%20Spa!5e0!3m2!1sen!2sin!4v1714387731959!5m2!1sen!2sin" width='100%' height='100%' allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </div>
      </div>
    </div>
  )
}